/*
 * @Author: Lim 
 * @Date: 2020-09-09 10:02:05 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-11 11:07:12
 */
import React, { Component } from 'react';
import E from 'wangeditor';
import faceIconContent from './faceImg.js';
import { unitFilter } from '../common';
import './iconfont/iconfont.css'

export default class Editor extends Component{
    constructor(props, context) {
        super(props, context);
        this.state = {
            config : {
                editorContent: '',
                width : "100%",
                height : 100,
                colors:['#000000','#eeece0','#1c487f','#4d80bf','#c24f4a','#8baa4a','#7b5ba1','#46acc8','#f9963b','#ffffff'],
                menus:['head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'foreColor', 'backColor', 'link', 'list', 'justify', 'quote', 'emoticon', 'image', 'table', 'video', 'code', 'undo', 'redo'],
                faceImg:[
                    {
                        title: '表情',
                        type: 'emoji',
                        content: ['😃', '😎', '😍', '😭', '😊', '😘', '👆', '👇', '👉', '👍', '👏', '✌️', '🔥', '💗', '💔', '🎁', '⚡️', '⭐', '💰', '📢', '🚫', '✅', '❌', '💯', '🔗', '☎️', '🍻', '🚩', '⬆️', '⬇️', '⬅️', '➡️', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '0️⃣']
                    },
                    {
                        title: '小黄人',
                        type: 'image',
                        content: faceIconContent
                    }
                ],
                change(){},
                focus(){},
                blur(){},
            }
        }
    }
    componentDidMount(){
        const { config } = this.state;
        if( !this.props ) return false;
        let newConfig = Object.assign(config,this.props.config);
        this.setState({
            config:newConfig
        })
        const elemMenu = this.refs.editorElemMenu;
        const elemBody = this.refs.editorElemBody;
        const editor = new E(elemMenu,elemBody) // 创建实例
        editor.customConfig.colors = this.state.config.colors;// 配置颜色
        editor.customConfig.emotions = this.state.config.faceImg; // 配置表情包
        editor.customConfig.menus = this.state.config.menus; // 配置菜单栏
        editor.customConfig.uploadImgShowBase64 = true// 使用 base64 保存图片
        // onchange
        editor.customConfig.onchange = html => {
            let { config } = this.state;
            config.editorContent = html;
            this.setState({ config });
            config.change(html);
        }
        // onblur
        editor.customConfig.onblur = html => {
            let { config } = this.state;
            config.blur(html);
        }
        // onfocus
        editor.customConfig.onfocus = () => {
            let { config } = this.state;
            config.focus();
        }
        editor.create();
        editor.txt.html(config.editorContent) // 默认文本
    }
    render () {
        const defaultWidth = unitFilter ( this.state.config.width );
        const defaultHeight = unitFilter ( this.state.config.height );
        return(
            <div style={{ width: defaultWidth }}>
                <div ref="editorElemMenu"
                        style={{backgroundColor:'#f1f1f1',border:"1px solid #ccc", flexWrap: "wrap"}}
                        className="editorElem-menu">
                    </div>
                    <div
                        style={{
                            height:defaultHeight,
                            border:"1px solid #ccc",
                            borderTop:"none"
                        }}
                        ref="editorElemBody" className="editorElem-body">
                    </div>
            </div>
        )
    }
}